/**
 * Who may work with employee credentials, as plain functions of the store's getters so the users
 * list and What's New answer the same way.
 */

interface CredentialGetters {
  hasCredentialFeature: boolean
  credentialsEnabled: boolean
  hasDocumentFeature: boolean
  canAccessEmployeeSensitiveField: (_field: string) => boolean
}

/** Allowed to see employees' credentials and their documents, whatever the plan. */
export function mayAccessCredentials (getters: CredentialGetters): boolean {
  return getters.canAccessEmployeeSensitiveField('credential') && getters.canAccessEmployeeSensitiveField('document')
}

/**
 * Can open the credential importer from the users list. Without the `credential_ai` feature it
 * still opens, as a preview behind an upsell banner.
 */
export function canOpenCredentialImport (getters: CredentialGetters): boolean {
  return getters.credentialsEnabled && getters.hasDocumentFeature && mayAccessCredentials(getters)
}

/**
 * The plan has credentials but the organization has not turned them on ("Enable Credentialing" in
 * the users' default settings), so the credential screens, the importer among them, are hidden.
 */
export function credentialingIsOff (getters: CredentialGetters): boolean {
  return getters.hasCredentialFeature && !getters.credentialsEnabled
}
